import { BigNumber } from '@frontend/numeric';

interface ICalculateProfitOrLossParams {
  profit: number;
  lotSize: number;
  openPrice: number;
  currentPrice: number;
  contractSize: number;
  exchangeRate: number;
  isSellOrder?: boolean;
}

export const calculateProfitOrLoss = (params: ICalculateProfitOrLossParams) => {
  const { profit, currentPrice, openPrice, contractSize, lotSize, exchangeRate, isSellOrder = false } = params;

  // If we don't have valid data for calculation, return the fallback profit
  if (currentPrice <= 0 || contractSize <= 0 || exchangeRate <= 0) {
    return BigNumber(profit);
  }

  const priceDiff = isSellOrder
    ? BigNumber(openPrice).minus(currentPrice) // For SELL: profit when price goes down
    : BigNumber(currentPrice).minus(openPrice); // For BUY: profit when price goes up

  // lotSize should be absolute value for calculation
  return priceDiff.times(contractSize).times(Math.abs(lotSize)).times(exchangeRate);
};
